export const getCurrentMonthKey = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

// Normalizes a "YYYY-M" or "YYYY-MM" key to zero-padded "YYYY-MM" so that
// plain string comparisons (localeCompare) sort chronologically.
// Without this, an unpadded key like "2026-6" sorts *after* "2026-07"
// because '6' > '0' character-by-character, swapping June and July.
export const normalizeMonthKey = (key) => {
  const [year, month] = key.split('-');
  return `${year}-${String(parseInt(month, 10)).padStart(2, '0')}`;
};

export const formatMonthKey = (key) => {
  const [year, month] = key.split('-');
  const date = new Date(year, parseInt(month) - 1);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
};

export const formatMonthShort = (key) => {
  const [year, month] = key.split('-');
  const date = new Date(year, parseInt(month) - 1);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
};
